// use for building replacement tags for answers_additional
import type { GameQuizQuestionAnswer } from '@/src/components/games/quiz/View.vue';
import type { GameQuizState } from '@/src/components/games/quiz/Model';
import { QuizAnswerTypes } from '@/src/components/games/quiz/Model';

export const buildAnswersAdditional = (questionAnswers: GameQuizQuestionAnswer[]) => {
  let html = '';
  if (questionAnswers.length > 0) {
    questionAnswers.forEach((answerObj) => {
      answerObj.answer.forEach((answer) => {
        if (answer.description && answer.description !== '') {
          html += `<li><span class="question-headline">${
            answerObj.question.questionString
          }</span> <span class="question-additional-answer">${answer.description.replace(/\|/gim, ', ')} </span></li>`;
        }
      });
    });
    return `<ul class="additional-answer">${html}</ul>`;
  }

  return html;
};

export const buildAnswersFlowOutput = (questionAnswers: GameQuizQuestionAnswer[]) => {
  let html = '';
  questionAnswers.forEach((answerObj) => {
    answerObj.answer.forEach((answer) => {
      let questionString = `${answerObj.question.question}`;
      let swipeItString = '';
      let additionalString = '';
      let answerString = answer.text ? answer.text.replace(/&#60;/gi, '<').replace(/&#62;/gi, '>') : '';
      const answerAdditionalString = answer.description
        ? answer.description.replace(/&#60;/gi, '<').replace(/&#62;/gi, '>')
        : '';

      if (answerObj.question.questionString && answerObj.question.questionString !== '') {
        questionString = `<h4 class='question'>${answerObj.question.questionString}</h4>`;
      }

      if (answerString.includes('files/')) {
        answerString = `<img src='${answerString}' width='100px'/>`;
      }

      if (answerObj.question.swipeImage) {
        swipeItString = `<img src='${answerObj.question.swipeImage.src}' width='100px'/>`;
      }

      if (answerAdditionalString && answerAdditionalString !== '') {
        additionalString = `<p class='flow-output__additional'>${answerAdditionalString.replace(/\\|/gim, ', ')}</p>`;
      }

      html += `<li class="flow-output__item">
                      <div class="flow-output__question">${questionString}</div>
                      <h5 class="flow-output__answer">${answerString}</h5>
                      ${swipeItString}${additionalString}
                   </li>`;
    });
  });

  return `<div class='flow-output'><ul class='flow-output__inner'>${html}</ul></div>`;
};

export const buildResultOutput = (state: GameQuizState, questionAnswers: GameQuizQuestionAnswer[]) => {
  let html = '';

  questionAnswers.forEach((answerObj) => {
    answerObj.answer.forEach((answer) => {
      let answerString = '';
      const answerResponseString = `<span>(${
        answerObj.question.correctAnswers.includes(answer.id)
          ? answerObj.question.correctString
          : answerObj.question.wrongString
      })</span>`;

      let questionString = `${answerObj.question.question}${answerResponseString}`;
      if (answerObj.question.questionString) {
        questionString = `${answerObj.question.questionString}${
          answerObj.question.correctAnswers.length > 1 ? answerResponseString : ''
        }`;
      }

      if (answerObj.question.answers.length > 0) {
        if (answerObj.question.answerType === QuizAnswerTypes.SWIPE) {
          answerString = `
                <h5 class='answer ${answer.id === 1 ? 'selected-answer' : ''}'>
                  ${state?.translation?.swipe?.left}  ${answer.id === 1 ? answerResponseString : ''}
                </h5>
                <h5 class='answer ${answer.id === 2 ? 'selected-answer' : ''}'>
                  ${state.translation?.swipe?.right}  ${answer.id === 2 ? answerResponseString : ''}
                </h5>
                `;
        } else {
          answerObj.question.answers.forEach((answerItem) => {
            let answerTextString = answerItem.text;

            if (answerItem.text.includes('files/')) {
              answerTextString = `<img src='${answerItem.text}' width='100px'/>`;
            }

            if (answer.text === answerItem.text) {
              answerTextString += answerResponseString;
            }

            // if answers have multiple correct answers
            // check if selected answer exits in array
            if (answerObj.question.correctAnswers.length > 1) {
              answerTextString = `<h5 class='answer ${
                answerObj.question.correctAnswers.includes(answerItem.id) ? 'selected-answer' : ''
              }'> ${answerTextString} </h5>`;
            } else {
              answerTextString = `<h5 class='answer ${
                answerObj.question.correctAnswers.includes(answerItem.id) ? 'selected-answer' : ''
              }'>${answerTextString} </h5>`;
            }

            // if there is description & answers have multiple correct answers
            // check if selected answer exits in array
            if (answerItem.description && answerItem.description !== '') {
              if (answerObj.question.correctAnswers.length > 1) {
                answerTextString += `<p class='answer-additional ${
                  answerObj.question.correctAnswers.includes(answerItem.id) ? 'selected-answer-additional' : ''
                }'>${answerItem.description}</p>`;
              } else {
                answerTextString += `<p class='answer-additional ${
                  answerObj.question.correctAnswers.includes(answerItem.id) ? 'selected-answer-additional' : ''
                }'>${answerItem.description}</p>`;
              }
            }
            answerString += answerTextString;
          });
        }
      }

      html += `<li class='result-output__item'>
                      <div class='result-output__question'>
                        <h4 class='question'>${questionString}</h4></div>
                      <div class='result-output__answers'>${answerString}</div>
                   </li>`;
    });
  });

  return `<div class='result-output'><ul class='result-output__inner'>${html}</ul></div>`;
};
